import React from 'react'
import Navbar from '../components/Navbar'
import Baner from '../components/Baner'
import bg from '../assets/bg-prawo.jpg'
import Footer from '../components/Footer'
import {AiOutlinePhone} from 'react-icons/ai'
import {BiMailSend} from 'react-icons/bi'
import {CiBookmarkCheck, CiBullhorn, CiRepeat, CiCoinInsert, CiBank, CiCalculator1, CiCalendar, CiCoins1} from 'react-icons/ci'

const Prawo = () => {

  const uslugi = [
    {
      id: 1,
      text: "porady prawne",
      icon: <CiBookmarkCheck size={60}/>
    },{
      id: 2,
      text: "reprezentacja sądowa",
      icon: <CiBullhorn size={60}/>
    },{
      id: 3,
      text: "obsługa prawa firm",
      icon: <CiBank size={60}/>
    },{
      id: 4,
      text: "podziały majątkowe, w tym nieruchomości",
      icon: <CiCalculator1 size={60}/>
    },{
      id: 5,
      text: "Prowadzenie spraw ze wszystkich zakresów Prawa",
      icon: <CiCalendar size={60}/>
    },{
      id: 6,
      text: "odszkodowania KREDYTÓW FRANKOWYCH",
      icon: <CiCoins1 size={60}/>
    },{
      id: 7,
      text: "sprawy spadkowe",
      icon: <CiCoinInsert size={60}/>
    },{
      id: 8,
      text: "Windykacja należności",
      icon: <CiRepeat size={60}/>
    },
  ]

  return (
    <div>
      <Navbar />
      <Baner bg={bg} text="USŁUGI PRAWNE" text2=""/>
      <div className='w-full'>
        <div className='justify-center flex mx-auto max-w-[1450px] bg-white'>
          <div className='text-center px-10'>

          <div className='px-10'>
            <h2 className='uppercase text-2xl font-semibold pt-20'>zakres naszych działań</h2>
            <div className='grid sm:grid-cols-3 pt-10'>
                {uslugi.map((item) => (
                  <div key={item.id} className='md:px-20 pt-10'>
                    <div className='mx-auto flex justify-center pb-2 text-[#4C4C9B]'>{item.icon}</div>
                    <h3 className='sm:text-lg uppercase'>{item.text}</h3>
                  </div>
                ))}
            </div>
          </div>

          <div className='mt-32 bg-[#4C4C9B] text-white py-6 px-10 rounded-2xl hover:shadow-lg duration-300'>
                <h2 className='text-2xl'>KONTAKT DO EXPERTA</h2>
                <h3 className='text-xl font-semibold py-5'>Maksymilian Paśko</h3>
                <div className='mx-auto flex justify-center'>
                  <div>
                    <div className='flex pr-10'>
                      <AiOutlinePhone size={25}/>
                      <p className='pl-2'>max@mecenasi.org</p>
                    </div>
                    <div className='flex pt-2'>
                      <BiMailSend size={25}/>
                      <p className='pl-2'>784-577-649</p>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Prawo